export default {
  "content": "<path d=\"M432 144l-28.67 275.74A32 32 0 01371.55 448H140.46a32 32 0 01-31.78-28.26L80 144\" class=\"ionicon-fill-none ionicon-stroke-width\"/><rect x=\"32\" y=\"64\" width=\"448\" height=\"80\" rx=\"16\" ry=\"16\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M312 240L200 352m112 0L200 240\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};